var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteralLoose(['\n  background: #fff;\n  height: ', ';\n  min-width: ', ';\n  max-width: ', ';\n  margin-top: ', ';\n  margin-right: 0px;\n  margin-bottom: 0px;\n  margin-left: 0px;\n  border: 2px solid ', ';\n  padding: 5px;\n  &:focus-within {\n    background-color: ', ';\n    box-shadow: rgba(10, 10, 10, 0.4) 1px 1px 12px;\n    filter: brightness(110%);\n    border-color: rgba(0, 0, 0, 0.1);\n    select {\n      color: #fff;\n    }\n  }\n  select {\n    width: 100%;\n    height: 100%;\n    border: none;\n    color: ', ';\n    background: transparent;\n    border: none;\n    background: inherit;\n    box-shadow: none;\n    padding-left: 11px;\n    padding-right: ', ';\n    font-size: 16px;\n    line-height: 22px;\n    letter-spacing: -0.175356px;\n    -webkit-appearance: none;\n    &:focus {\n      outline: none;\n      background-color: ', ';\n      background-image: none;\n    }\n  }\n'], ['\n  background: #fff;\n  height: ', ';\n  min-width: ', ';\n  max-width: ', ';\n  margin-top: ', ';\n  margin-right: 0px;\n  margin-bottom: 0px;\n  margin-left: 0px;\n  border: 2px solid ', ';\n  padding: 5px;\n  &:focus-within {\n    background-color: ', ';\n    box-shadow: rgba(10, 10, 10, 0.4) 1px 1px 12px;\n    filter: brightness(110%);\n    border-color: rgba(0, 0, 0, 0.1);\n    select {\n      color: #fff;\n    }\n  }\n  select {\n    width: 100%;\n    height: 100%;\n    border: none;\n    color: ', ';\n    background: transparent;\n    border: none;\n    background: inherit;\n    box-shadow: none;\n    padding-left: 11px;\n    padding-right: ', ';\n    font-size: 16px;\n    line-height: 22px;\n    letter-spacing: -0.175356px;\n    -webkit-appearance: none;\n    &:focus {\n      outline: none;\n      background-color: ', ';\n      background-image: none;\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  border-radius: ', ';\n'], ['\n  border-radius: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  .select-active {\n    background-color: ', ';\n    box-shadow: rgba(10, 10, 10, 0.4) 1px 1px 12px;\n    filter: brightness(110%);\n    border-color: rgba(0, 0, 0, 0.3);\n    select {\n      color: #fff;\n      background-color: ', ';\n    }\n    &:focus-within {\n      background-color: ', ';\n      box-shadow: rgba(10, 10, 10, 0.4) 1px 1px 12px;\n      filter: brightness(110%);\n      border-color: rgba(0, 0, 0, 0.1);\n      select {\n        color: #fff;\n      }\n    }\n  }\n'], ['\n  .select-active {\n    background-color: ', ';\n    box-shadow: rgba(10, 10, 10, 0.4) 1px 1px 12px;\n    filter: brightness(110%);\n    border-color: rgba(0, 0, 0, 0.3);\n    select {\n      color: #fff;\n      background-color: ', ';\n    }\n    &:focus-within {\n      background-color: ', ';\n      box-shadow: rgba(10, 10, 10, 0.4) 1px 1px 12px;\n      filter: brightness(110%);\n      border-color: rgba(0, 0, 0, 0.1);\n      select {\n        color: #fff;\n      }\n    }\n  }\n']);

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
import { isNil, isEmpty } from 'ramda';
import InputContainer from '../InputContainer';
import colours from '../../Utils/colours';
import Label from '../Label';
var StyledSelectContainer = styled.div(_templateObject, function (props) {
  return props.theme.spaces.extraLoose;
}, function (props) {
  return props.size ? props.theme.dropdown.sizes[props.size]['min'] : props.theme.spaces.loose;
}, function (props) {
  return props.size ? props.theme.dropdown.sizes[props.size]['max'] : 'auto';
}, function (props) {
  return props.theme.spaces.tight;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return colours(props.theme, props.colour, 'base');
}, function (props) {
  return props.theme.colours.neutral.darkest;
}, function (props) {
  return props.theme.spaces.base;
}, function (props) {
  return colours(props.theme, props.colour, 'base');
});
var SquareSelect = styled(StyledSelectContainer)(_templateObject2, function (props) {
  return props.theme.radius;
});
var RoundSelect = styled(StyledSelectContainer)(_templateObject2, function (props) {
  return props.theme.radius;
});
var StyledOuterContainer = styled.div(_templateObject3, function (props) {
  return colours(props.theme, props.colour, 'dark');
}, function (props) {
  return colours(props.theme, props.colour, 'dark');
}, function (props) {
  return colours(props.theme, props.colour, 'base');
});

var Select = function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select() {
    _classCallCheck(this, Select);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Select.prototype.render = function render() {
    var _props = this.props,
        round = _props.round,
        children = _props.children,
        value = _props.value,
        size = _props.size,
        label = _props.label,
        rest = _objectWithoutProperties(_props, ['round', 'children', 'value', 'size', 'label']);

    var SelectContainer = round ? RoundSelect : SquareSelect;
    var hasValue = !isNil(value) && value !== '' && value !== 'Please Select';
    var dropdownClass = hasValue ? 'select-active' : '';
    var hasLabel = !isNil(label) && !isEmpty(label);
    return React.createElement(InputContainer, null, React.createElement(StyledOuterContainer, null, hasLabel && React.createElement(Label, null, label), React.createElement(SelectContainer, {
      size: size,
      className: dropdownClass
    }, React.createElement('select', _extends({}, rest, {
      value: value
    }), children))));
  };

  return Select;
}(React.Component);

export { Select as default };